import * as R from 'ramda';

export default function EditInternalContactDialogController(
  $rootScope,
  $scope,
  $q,

  loaderService,
  alerts,
  ssDialogService,
  orgDataService,
) {
  const vm = this;
  vm.newUser = R.clone(vm.user);

  vm.handleFormSubmit = _handleFormSubmit;
  vm.handleCloseDialogClick = _handleCloseDialogClick;

  function _handleFormSubmit() {
    if ($scope.editInternalContactForm.$valid) {
      loaderService.showViewLoader = true;

      if (vm.newUser.firstName.trim() !== '' && vm.newUser.lastName.trim() !== '') {
        vm.newUser.fullName = `${vm.newUser.firstName.trim()} ${vm.newUser.lastName.trim()}`;
      }

      orgDataService.updateUser(vm.newUser).then(() => {
        loaderService.showViewLoader = false;
        alerts.success('The Internal Contact has been successfully saved.');
        $rootScope.$broadcast('refreshInternalContacts');
        //$rootScope.$broadcast('refreshStatuses');
        $rootScope.$broadcast('refreshBCPAssessments');
        _closeDialog();
      });
    }
  }

  function _handleCloseDialogClick() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editInternalContactDialog);
  }
}

EditInternalContactDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',

  'loaderService',
  'alerts',
  'ssDialogService',
  'orgDataService',
];
